import { Pagination, Stack } from '@mui/material'

type Props = {
  total: number
  rowsPerPage: number
  page: number
  onPageChange: (page: number) => void
}

export const TablePagination = ({
  total,
  rowsPerPage,
  page,
  onPageChange,
}: Props) => {
  const count = Math.ceil(total / rowsPerPage)

  return (
    <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
      <Pagination
        count={count}
        page={page + 1}
        color="primary"
        onChange={(_event, newPage) => onPageChange(newPage - 1)}
      />
    </Stack>
  )
}
